import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

export function SettingsBillingPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Billing</h1>
        <p className="text-muted-foreground">Manage your subscription and billing information.</p>
      </div>

      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle>Current Plan</CardTitle>
              <CardDescription>You are currently on the free plan.</CardDescription>
            </div>
            <Badge>Free</Badge>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="rounded-lg border p-4">
            <h3 className="font-semibold">Free Plan</h3>
            <ul className="mt-2 space-y-1 text-sm text-muted-foreground">
              <li>Up to 3 team members</li>
              <li>Basic pipeline tracking</li>
              <li>Commission calculator</li>
              <li>Email support</li>
            </ul>
          </div>

          <div className="rounded-lg border border-primary/20 bg-primary/5 p-4">
            <h3 className="font-semibold">Pro Plan — Coming Soon</h3>
            <ul className="mt-2 space-y-1 text-sm text-muted-foreground">
              <li>Unlimited team members</li>
              <li>AI-powered nudges</li>
              <li>Slack integration</li>
              <li>Advanced reporting</li>
              <li>Multi-currency support</li>
              <li>Priority support</li>
            </ul>
            <Button className="mt-4" disabled>
              Upgrade (Coming Soon)
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
